import { useMemo } from 'react';
import { MA_CHUNG_TU, QUERY_KEYS } from '@/constants';
import { useCRUD } from '@/hooks';

type TransactionOption = {
  value: string;
  label: string;
};

type TransactionRow = {
  uuid: string;
  ma_gd?: string;
  ten_gd?: string;
};

export function useDonHangMuaTrongNuocTransactionOptions(): TransactionOption[] {
  const { data } = useCRUD<TransactionRow>({
    endpoint: `${QUERY_KEYS.MA_GIAO_DICH}?ma_ct=${MA_CHUNG_TU.MUA_HANG.DON_HANG_MUA_TRONG_NUOC}`
  });

  return useMemo(
    () =>
      data.map(item => ({
        value: item.uuid,
        label: item.ten_gd || item.ma_gd || item.uuid
      })),
    [data]
  );
}
